var React = require('react');

function ButtonPlayInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","fill":"#fff","key":0}),React.createElement("path",{"d":"M18.75 15l-5.625 3.248v-6.496L18.75 15z","fill":"#2D2D2D","key":1})]);
}

ButtonPlayInline.defaultProps = {"viewBox":"0 0 30 30","fill":"none"};

module.exports = ButtonPlayInline;

ButtonPlayInline.default = ButtonPlayInline;
